import { useTranslation } from 'react-i18next';
import type { Language } from '@/i18n';

/** Returns a picker that reads the Arabic or English field for the active language. */
export function useLocalizedName() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  return (nameEn: string, nameAr: string) => (isArabic ? nameAr : nameEn);
}

export function useLanguage(): Language {
  const { i18n } = useTranslation();
  return i18n.language === 'en' ? 'en' : 'ar';
}
